import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { toCamel } from 'convert-keys';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { Locale } from 'src/app/shared/model/locale.model';
import { GenericOldService } from './generic-old.service';

@Injectable()
export class LocaleService {
  private locales$: Observable<Locale[]>;
  private _locales: Locale[];

  get locales(): Locale[] {
    return this._locales;
  }

  constructor(private resourceService: GenericOldService<Locale[]>) {}

  getLocales(): Observable<Locale[]> {
    if (!this.locales$ && !this._locales) {
      this.locales$ = this.resourceService.get(`reference/locales`).pipe(
        map(item => {
          this._locales = toCamel<Locale[]>(item);
          return this._locales;
        }),
        shareReplay(1),
      );
    }
    return this.locales$;
  }
}
